import { Search } from '@beamery/lib-ds-icons';
import styled, { css } from 'styled-components';
import { Button } from '../button/index.js';
import { InputContainerElement, } from './input.styles.js';
export const SearchIconElement = styled(Search).attrs({
    size: 'standard',
    color: 'inherit',
}) `
  flex-shrink: 0;
`;
export const CloseButtonElement = styled(Button).attrs({ variant: 'plain' }) `
  overflow: visible;
`;
const getSearchContainerInactiveStyles = ({ theme, }) => css `
  ${SearchIconElement} {
    color: ${theme.styles.inputs.states.inactive.iconColor};
  }

  ${CloseButtonElement} {
    color: ${theme.styles.inputs.states.inactive.actionColor};
  }
`;
const getSearchContainerHoverStyles = ({ theme, }) => css `
  &:hover {
    ${SearchIconElement} {
      color: ${theme.styles.inputs.states.hover.iconColor};
    }

    ${CloseButtonElement} {
      color: ${theme.styles.inputs.states.hover.actionColor};
    }
  }
`;
const getSearchContainerActiveStyles = ({ theme, }) => css `
  &:focus-within {
    ${SearchIconElement} {
      color: ${theme.styles.inputs.states.active.iconColor};
    }

    ${CloseButtonElement} {
      color: ${theme.styles.inputs.states.active.actionColor};
    }
  }
`;
const getSearchContainerDisabledStyles = ({ theme, isDisabled, }) => {
    if (isDisabled)
        return css `
      &:not(:hover),
      &:hover {
        ${SearchIconElement} {
          color: ${theme.styles.inputs.states.disabled.iconColor};
        }
      }
    `;
    return css ``;
};
const getSearchContainerOnGrayStyles = ({ theme, isOnGray, }) => {
    if (isOnGray)
        return css `
      background: ${theme.colors.controls.secondaryOnGray};
    `;
    return css ``;
};
export const SearchContainerElement = styled(InputContainerElement)(({ theme }) => css `
    ${SearchIconElement} {
      margin-right: ${theme.space.x1};
    }

    ${CloseButtonElement} {
      margin-left: ${theme.space.x1};
    }
  `, getSearchContainerInactiveStyles, getSearchContainerHoverStyles, getSearchContainerActiveStyles, getSearchContainerDisabledStyles, getSearchContainerOnGrayStyles);
//# sourceMappingURL=search-field.styles.js.map